export default __webpack_public_path__ + "static/media/15.580a0c87.jpg";